import DashboardIcon from "@mui/icons-material/Dashboard";
import { Box, Typography } from "@mui/material";
import React from "react";

const NoDataContainer = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        mb: 4,
      }}
    >
      <DashboardIcon sx={{ fontSize: "8rem", my: 10 }} color="gray" />
      <Typography color="gray" variant="h6" fontWeight="bold">
        داده ای جهت نمایش وجود ندارد
      </Typography>
    </Box>
  );
};

export default NoDataContainer;
